module.exports = __webpack_public_path__ + "bienestara3mil.png";